import { answerColors } from "@ai-teach/canvas-styles";
import type { CSSProperties } from "react";

/** How a choice came out of a finished play; undefined while it is still unanswered. */
export type GradedState = "correct" | "wrong" | undefined;

/** Green on the correct answer, red on a wrong pick — the grading mobile paints during play. */
export function gradeChoice(
  isCorrectAnswer: boolean,
  isPicked: boolean | undefined,
  isFrozen: boolean | undefined
): GradedState {
  if (!isFrozen) return undefined;
  if (isCorrectAnswer) return "correct";
  return isPicked ? "wrong" : undefined;
}

/** Text choices: the whole pill takes the colour, with the label reversed out of it. */
export function gradedFillStyle(state: GradedState): CSSProperties {
  if (!state) return {};
  const color = state === "wrong" ? answerColors.wrong : answerColors.correct;
  return { backgroundColor: color, borderColor: color, color: "#ffffff" };
}

/** Image choices: a ring and a tint, so the picture itself stays readable. */
export function gradedRingStyle(state: GradedState): CSSProperties {
  if (!state) return {};
  return state === "wrong"
    ? { border: `3px solid ${answerColors.wrong}`, backgroundColor: answerColors.wrongSoft }
    : { border: `3px solid ${answerColors.correct}`, backgroundColor: answerColors.correctSoft };
}
